module.exports = __webpack_public_path__ + "media/images/svg/clients/13-cf2295b2d18019303a97ae5e08f5cf76.svg";